import { apiSchemas } from '@verifime/api-definition';
import type { TEntityChoice } from '@verifime/components';
import { z } from 'zod';

export type TEntityConfirmation = z.infer<typeof apiSchemas.EntityConfirmation>;

/**
 * The body of `PUT /v1/tracking/{trackingReference}/confirmation` for a choice. `entityType` is
 * required by the contract: just me (no entity) is `Individual`. The portal's own choice stays
 * `'individual'`; it becomes `Individual` here, at the request boundary.
 */
export const toEntityConfirmation = (choice: TEntityChoice): TEntityConfirmation => ({
  entityType: choice === 'individual' ? 'Individual' : choice,
});
